<template>
    <div class="home-page">
        <flickity-box class="flickity" ref="flickity" :options="flickityOptions">
            <div class="carousel-cell" v-for="n in 4">
                <img :src="require('../assets/home_' + n +'.png')" />
            </div>
        </flickity-box>
    </div>
</template>

<script>
  import FlickityBox from './FlickityBox';

  export default {
    components: {
      FlickityBox,
    },
    props: ['lang'],
    data() {
      return {
        facebookUrl: 'https://www.facebook.com/Les-Gants-dAm%C3%A9lie-309750282382568/',
        flickityOptions: {
          freeScroll: false,
          imagesLoaded: true,
          pageDots: false,
          wrapAround: true,
          adaptiveHeight: false,
          cellAlign: 'left',
          autoPlay: true,

        },
      };
    },
  };
</script>

<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/HomePage.vue